import React from 'react';
import { Grid, Skeleton, Typography } from '@mui/material';

interface FoodListTitleSkeletonProps {
}

const FoodListTitleSkeleton: React.FC<FoodListTitleSkeletonProps> = ({ }) => {
    return (
        <Grid container justifyContent="flex-start" alignItems="center">
            <Skeleton height={32} width={28} />
            <Typography
                ml={1}
                fontWeight={600}>
                <Skeleton width={70} />
            </Typography>
        </Grid>
    )
}

export default FoodListTitleSkeleton;